export default __webpack_public_path__ + "assets/pdf/PlattJointCheckAgreement.ed859aae.pdf";